import { q, client } from "../helpers/init-db";

export function getEducations() {
  const current_date = new Date().toISOString().split('T')[0];
  return client.query(
    q.Map(
      q.Paginate(
        q.Range(
          q.Match(
            q.Index('educations_by_published_and_end_date'),
            true
          ),
          current_date, null
        )
      ),
      q.Lambda('ref', q.Get(q.Var('ref')))
    )
  )
    .then(resp => resp.data)
    .catch(err => {
      console.error('Problem getting educations', err);
      throw err;
    });
}

/**
 *
 * @param educationID - ID of the education
 */
export function GetEducationByID(educationID) {
  return client
    .query(
      q.Get(q.Ref(q.Collection("educations"), educationID))
    )
    .then(resp => resp)
    .catch(err => err);
}
